import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=f8978efc&scoped=true&"
import script from "./Price.vue?vue&type=script&lang=js&"
export * from "./Price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8978efc",
  null
  
)

export default component.exports